// extracted by mini-css-extract-plugin
export default {"UserResponseContainer":"UserResponse_UserResponseContainer__XSvl8","UserResponse":"UserResponse_UserResponse__r9xwP"};